export enum ReachReportTypeEnum {
    ReachPeople = 1,
    ReachVehicles = 2
  }